import { Button as MuiButton } from "@mui/material";
import styled from "styled-components";

export const StyledButton = styled(MuiButton)`
  text-transform: none;

  /* Читаем пропсы, которые мы пробросили как $width, $height и т.д. */
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  font-size: ${({ $fontSize }) => $fontSize};
  border-radius: ${({ $borderRadius }) => $borderRadius};
  
  /* Слева и справа у нас paddingX (чтобы выдержать отступы) */
  padding-left: ${({ $paddingX }) => $paddingX};
  padding-right: ${({ $paddingX }) => $paddingX};
  
  /* Если используете иконки MUI, 
     MUI сам расставляет отступ для startIcon/endIcon. 
     Если нужно, можно дополнительно учесть $gap. */
  gap: ${({ $gap }) => $gap};


  background-color: ${({ theme }) => theme.components.button.primary.backgroundEnabled};
  color: ${({ theme }) => theme.components.button.primary.content};
  border: 1px solid ${({ theme }) => theme.components.button.secondaryAndText.contentAndBorderEnabled};

  &:hover {
    background-color: ${({ theme }) => theme.components.button.primary.backgroundHovered};
  }

  &:focus {
    background-color: ${({ theme }) => theme.components.button.primary.backgroundFocused};
    border: 1px solid ${({ theme }) => theme.components.button.primary.borderAndContentFocused};
  }

  &:active {
    background-color: ${({ theme }) => theme.components.button.primary.backgroundPressed};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.components.button.primary.backgroundDisabled};
    color: ${({ theme }) => theme.components.button.secondaryAndText.contentAndBorderDisabled};
  }

  .MuiButton-startIcon {
    margin-right: 0; 
  }
  `;